import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "../../../../i18n.js";
import CloseModalButton from "./CloseModalButton.js";
import ModoProfesorSwitch from "./ModoProfesorSwitch.js";

function ModalHeader({ toggleModal, modalTitle, lang, noBorder = false, modoProfesor, setModoProfesor }) {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    if (lang) changeLanguage(lang);
  }, []);

  return (
    <div className="max-w-screen-xl	mx-auto">
      <div className={`flex justify-between align-center absolute top-0 left-0 w-full p-4 ${noBorder ? '' : 'border border-b-[#dcdcdc]'}`}>
        <p className="text-2xl text-nimbus">{modalTitle}</p>
        <div className="flex items-center gap-4">
          <ModoProfesorSwitch modoProfesor={modoProfesor} setModoProfesor={setModoProfesor} />
          <button onClick={toggleModal}>
            <CloseModalButton />
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalHeader;
